export default {"src":"/_next/static/media/rentbuycalc.5d656eab.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};